module.exports = __webpack_public_path__ + "static/media/chinese_dabao_2.d3ab11dd.png";